import { Delay } from '@rtls/core/models/convoy/delay.model';
import { nullable, randomDate, randomNumber, randomWord } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const delayFactory = Factory.makeFactory<Delay>({
	date: Factory.each(() => randomDate()),
	distance: Factory.each(() => randomNumber(true) * 1000),
	time: Factory.each(() => randomNumber(true) * 1000),
	length: Factory.each(() => randomNumber(true) * 1000),
	error: Factory.each(() => nullable(randomWord(), 95)),
});
